/**
 * @file Root entry point into framework
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

import './sass/main.scss'

import { AUTOSPIN_VALUES }       from './constants/autospin-values/autospin-values.constant'
import { BET_VALUES }            from './constants/bet-values/bet-values.constant'
import { ButtonManager }         from './classes/buttonManager/buttonManager.class'
import { BUTTON_STATES_MANAGER } from './constants/buttonStatesManager/button-states-manager.constant'
import { GAME_STATES }           from './constants/gameStates/game-states.constant'
import { VERSION }               from './constants/version.constant'

window.AUTOSPIN_VALUES       = AUTOSPIN_VALUES
window.BET_VALUES            = BET_VALUES
window.ButtonManager         = ButtonManager
window.BUTTON_STATES_MANAGER = BUTTON_STATES_MANAGER
window.GAME_STATES           = GAME_STATES